// extracted by mini-css-extract-plugin
export default {"footer":"K_bY","row":"K_dG","menuColumn":"K_dH","trademarks":"K_dJ"};